export { default } from './DestinationsScreen';
export * from './DestinationsScreen';
